import React from 'react'
import {
  FacebookShareButton,
  TwitterShareButton,
} from 'react-share' // https://github.com/nygardk/react-share
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'

import './Share.css'

const Share = ({ url, title }) => {
  return (
    <div className="share-container">
      <div className="share-item-icon">
        <FacebookShareButton
          url={url}
          quote={title}>
          <FontAwesomeIcon icon={faFacebook} />
        </FacebookShareButton>
      </div>
      <div className="share-item-icon">
        <TwitterShareButton
          url={url}
          title={title}>
          <FontAwesomeIcon icon={faTwitter} />
        </TwitterShareButton>
      </div>
    </div>
  )
}

export default Share